import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { VehicleMileagePage } from './mileage';

@NgModule({
  declarations: [VehicleMileagePage],
  imports: [IonicPageModule.forChild(VehicleMileagePage)],
})
export class VehicleMileagePageModule {}



// WEBPACK FOOTER //
// ./src/pages/fleet/mileage/mileage.module.ts